// Translation: Account > Profile > General information (Turkish)
export default Object.freeze({
	input : {
		label: 'Biyografi',
		placeholder: 'Biyografinizi girin'
	},
	title: 'Genel bilgiler'
})
